<template>
  <v-container fluid grid-list-md fill-height class="godawn-details">
    <v-layout row wrap>
      <v-flex xs12 sm12 md12>
        <v-toolbar class="primary white--text">
          <router-link to="/Dashboard">
            <v-btn icon dark >
              <v-icon>keyboard_backspace</v-icon>
            </v-btn>
          </router-link>
          <v-toolbar-title >Sales Team</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
         <v-layout row wrap>
          <v-flex xs12 md12>
            <v-card-text>
              <v-layout row wrap>
                <v-flex
                  xs12
                  md3
                  sm3
                  v-for="staff in staffByBrand"
                  :key="staff['.key']"
                  style="padding:15px"
                >
                  <v-card class="icon-card">
                    <v-icon style="padding: 18px 18px;">business</v-icon>
                  </v-card>
                  <v-card class="sec1-card" :key="staff['.key']+'G'">
                    <v-card-title primary-title class="headline">
                      <v-spacer />
                      {{staff.staffName}}
                    </v-card-title>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <b class="subheading primary--text font-weight-light">{{firmbyId(staff.firm)}}</b>
                      <v-spacer></v-spacer>
                    </v-card-actions>
                      <v-card-actions>
                      <v-spacer></v-spacer>
                      Opening Balance : <span>{{staff.openingBalance}}</span>
                      <v-spacer></v-spacer>
                      Rate : <span>{{staff.brokerageRate}}</span>
                      <v-spacer></v-spacer>
                    </v-card-actions>
                      <v-btn outline class="primary white--text" @click="openStaffTransactions(staff)">
                      <v-icon left class="primary--text">remove_red_eye</v-icon>
                      <a class="primary--text font-weight-light">View Transactions</a>
                      </v-btn>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-flex>
         </v-layout>
      </v-flex>
    </v-layout>
    <v-dialog v-model="viewTransaction" fullscreen hide-overlay>
      <v-card v-if="currentStaff">
        <v-card-title class="primary white--text">
          <span class="headline">{{currentStaff.staffName}} - Transactions</span>
          <v-spacer />
          <v-btn icon dark @click.native="viewTransaction = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
        <v-data-table :items="currentStaffInvoices" class="elevation" :headers="staffTransactionHeaders">
        <template slot="items" slot-scope="props">
          <!-- <td>{{new Date(props.item.date).toLocaleDateString('en-GB')}}</td> -->
          <td class="primary--text font-weight-bold" v-html="renderDate(props.item.date)"></td>
          <td>{{ props.item.invoiceId}}</td>
          <td>{{ getCurrentUserName(props.item.buyerId)}}</td>
          <td>{{ props.item.brokerageRate}}</td>
          <td class="primary--text font-weight-bold">{{ ((props.item.totalAmount * props.item.brokerageRate)/100) | amount}}</td>
          <td class="red--text font-weight-bold">{{ props.item.totalAmount | amount}}</td>
          <td>{{ props.item.status}}</td>
          <td v-if="!props.item.brokeragePaid"> <v-btn outlined @click="openPayBrokerage(props.item)" class="primary--text">
            PAY
          </v-btn></td>
          <td v-else v-html="'Paid on ' + renderDate(props.item.brokeragePayDate)"></td>
          <td>{{ firmbyId(props.item.firm)}}</td>
        </template>
        <template slot="no-data">no record found</template>
      </v-data-table>
      </v-card-text>
    </v-card>
  </v-dialog>
  <v-dialog v-model="dialog" persistent max-width="1000px">
    <v-card persistent>
        <v-card-title class="primary white--text">
          <span class="headline">Payment for {{currentPaymentGSTType}}</span>
          <v-spacer></v-spacer>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field type="number"
                  v-model="payableAmount"
                  disabled label="Net Payable" readonly prefix>
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm3 md3 >
                <v-menu
                  :close-on-content-click="false"
                  v-model="datepicker"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="selectedDate"
                    label="Date"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="selectedDate" @input="datepicker = false"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 sm3 m3 >
                      <v-select
                        dense
                        :items="[{
                                  text: 'Cash',
                                  value: 'Cash'
                                }, {
                                  text: 'Bank Account',
                                  value: 'Bank Account'
                                }]"
                        label="Select Payment Type"
                        v-model="paymentType"
                      ></v-select>
                  </v-flex>
                    
                    <v-flex xs12 sm3 md3>
                      <v-select
                        dense
                        :items="banksByFirms"
                        v-if="['Bank Account','CashAndBank Account'].includes(paymentType)"
                        label="Select Bank"
                        v-model="selectedBank"
                        flat
                        clearable
                        item-text="bankName"
                        return-object
                        :disabled="paymentType == 'Cash' || paymentType == ''"
                      ></v-select>
                    </v-flex>
                  
            </v-layout>
          </v-container>
          </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                class="grey white--text"
                @click="dialog = false"
                flat
              >Cancel</v-btn>
              <v-btn
                class="primary white--text"
                @click="payBrokerage()"
                flat
              >Pay</v-btn>
        </v-card-actions>
       </v-card>
      </v-dialog>
  </v-container>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
export default {
  data() {
    return {
      viewTransaction : false,
      currentStaff : null,
      currentInvoice : null,
      currentPaymentGSTType: null,
      dialog : false,
      payableAmount : 0,
      datepicker : false,
      selectedDate : new Date().toISOString().substr(0, 10),
      paymentType : '',
      selectedBank : null,
      amountFromCash : 0,
      amountFromBank : 0,
      currentStaffInvoices : [],
        staffTransactionHeaders: [
        { text: "Date", value: "date", sortable: true },
        { text: "Invoice ID", value: "date", sortable: true },
        { text: "Customer", value: "date", sortable: true },
        { text: "Brokerage Rate", value: "date", sortable: true },
        { text: "Brokerage Amount", value: "date", sortable: true },
        { text: "Invoice Amount", value: "date", sortable: true },
        { text: "Status", value: "date", sortable: true },
        { text: "Action", value: "date", sortable: true },
        { text: "Firm", value: "date", sortable: true },
      ],
    };
  },
  created() {
    this.$bindAsArray(
      'firms',
      this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand)
    ),
    this.$bindAsArray(
      'staff',
      this.$root.$firebaseRefs.staff.orderByChild('brand').equalTo(this.selectedBrand)
    ),
    this.$bindAsArray(
      'invoice',
      this.$root.$firebaseRefs.invoice.orderByChild('brand').equalTo(this.selectedBrand)
    ),
    this.$bindAsObject("buyerById", this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand)),
    this.$bindAsObject("sellerById", this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand))
     this.$bindAsArray("banks", this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand));
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand"]),
   staffByBrand() {
      return this.staff
        .filter(item => {
          return (
            item["brand"] === this.selectedBrand
          );
        })
    },
     banksByFirms() {
      return this.banks
        .filter(item => {
          return (
            item["brand"] === this.selectedBrand &&
            item["firm"] === this.currentInvoice.firm
          );
        })
    },  
  },
  methods: {
      openPayBrokerage(inv){
        this.dialog = true;
        this.currentInvoice = inv;
        this.payableAmount = ((Number.parseFloat(inv.totalAmount) * Number.parseFloat(inv.brokerageRate))/100);
        this.paymentType = 'Cash';
      },
      payBrokerage(){
      if(this.paymentType == 'Cash') {
        let firm = this.firms.filter(item => item['.key'] == this.currentInvoice.firm)[0];
        if(firm) {
        firm.amount = (Number.parseFloat(firm.amount) - Number.parseFloat(this.payableAmount));
          let key = firm['.key']
          delete firm['.key']
          this.$root.$firebaseRefs.firm.child(key).set(firm);
          this.updateInvoice(this.currentInvoice);
        }
      } else {
        let bank = this.banks.filter(item => item['.key'] == this.selectedBank)[0];
        if(bank) {
        bank.amount = (Number.parseFloat(bank.amount) - Number.parseFloat(this.payableAmount));
          let key = bank['.key']
          delete bank['.key']
          this.$root.$firebaseRefs.account.child(key).set(bank);
          this.updateInvoice(this.currentInvoice);
        }
      }
      this.dialog = false;
    },
    updateInvoice(inv){
      inv['brokeragePaid'] = true;
      inv['brokeragePayDate'] = new Date(this.selectedDate).getTime();
      inv['brokeragePaymentType'] = this.paymentType;
      let key = inv['.key']
      delete inv['.key']
      this.$root.$firebaseRefs.invoice.child(key).set(inv);
    },
    getCurrentUserName(buyerId) {
        let buyer = this.buyerById[buyerId];
        let seller = this.sellerById[buyerId];
        let currentUser =
        buyer && buyer.state ? buyer : seller && seller.state ? seller : {};
        return currentUser.name;
    },
   openStaffTransactions(staff){
     this.currentStaff = staff;
     this.currentStaffInvoices = this.invoice.filter(item => item['brand'] == this.selectedBrand && item['soldBy'] == staff['.key'] && item['brokerageRate'] != undefined );
     this.viewTransaction = true;
   },
   firmbyId(id){
      return this.firms.filter(item => item['.key'] == id)[0].name
    },
   renderDate(timeStamp) {
      if (timeStamp) {
        return new Date(timeStamp).toLocaleDateString("en-GB");
      }
      return "--";
    },
  }
};
</script>

<style scoped>
.card__text.number {
  font-size: xx-large;
  font-weight: bolder;
}

.godawn-details .sec1-card {
  background-color: #ffffff !important;
  border-color: #ffffff !important;
  color: #15155d !important;
  font-weight: bold;
  font-size: 14px;
  padding: 10px;
}

.godawn-details .headline {
  font-weight: bold;
  margin-left: 70px;
}

.godawn-details .v-card__title--primary {
  padding: 5px;
}

.godawn-details .icon-card {
  width: 60px;
  height: 60px;
  z-index: 2;
  top: 30px;
  background: #15155d;
  left: 10px;
}

.godawn-details .icon-card i {
  padding: 12px;
  color: white;
}

.godawn-details .sec3-card {
  position: relative;
  bottom: 7px;
  margin-bottom: 10px;
  font-size: 20px;
  text-align: left;
  padding-left: 9px;
  color: #15155d;
  font-weight: bold;
}
/* .dashboardHead th.column.text-xs-left {
  text-align: center !important;
} */
</style>



// WEBPACK FOOTER //
// src/components/Staffs/staff.vue